import moment from "moment";
import { FC } from "react";
import { Resource } from "../resources";

export interface JobProjectInfoProps {
  resource: Resource;
}

export const JobProjectInfoTab: FC<React.PropsWithChildren<JobProjectInfoProps>> = (props: JobProjectInfoProps) => {
  return (
    <dl className="d-table">
      <div className="d-table-row">
        <dt className="d-table-cell label-s">Name: </dt>
        <dd className="d-table-cell ps-2">{props.resource.name}</dd>
      </div>
      <div className="d-table-row">
        <dt className="d-table-cell label-s">Status: </dt>
        <dd className="d-table-cell ps-2">{props.resource.resourceStatus.toString().charAt(0).toUpperCase() + props.resource.resourceStatus.toString().slice(1)}</dd>
      </div>
      <div className="d-table-row">
        <dt className="d-table-cell label-s">Date Created: </dt>
        <dd className="d-table-cell ps-2">{moment.utc(props.resource.dateCreated).local().format("L LT")}</dd>
      </div>
      <div className="d-table-row">
        <dt className="d-table-cell label-s">Date Last Updated: </dt>
        <dd className="d-table-cell ps-2">{moment.utc(props.resource.dateLastUpdated).local().format("L LT")}</dd>
      </div>
    </dl>);
}